import { Badge, Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const ApnCountCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            <Badge size={'xs'}>{rowData.apns?.length || '0'}</Badge>
        </Box>
    );
};

const ApnCountColumn = () => ({
    accessorKey: 'apns.length',
    header: 'APNs',
    size: 1,
    Cell: ({ cell }) => <ApnCountCell cell={cell} />,
});
export default ApnCountColumn;
